const stopPropagation = (callback) => (e) => {
  e.preventDefault();
  e.stopPropagation();
  callback(e);
};

export default stopPropagation;
